/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import React from "react";

import { Box, SxProps } from "@mui/material";

export interface ConditionalBoxProps {
    hidden: boolean;
    children: JSX.Element | JSX.Element[];
    sx?: SxProps;
}

const ConditionalBox = (props: ConditionalBoxProps) => {
    const { hidden, children, sx } = props;

    if (hidden) return <Box />;

    return <Box sx={sx ?? {}}>{children}</Box>;
};

export default ConditionalBox;
